import { useTranslation } from "react-i18next";
import ThankYouMessage from "../ThankYouMessage";
import RenewalHeader from "./RenewalHeader";
import { useEffect } from "react";
import { windowScroll } from "../../../helpers/shared/useNavigationEffects";
import { Footer } from "../../tpa/components/Footer";

const RenewalSuccess = () => {
  const { t } = useTranslation("pages", { keyPrefix: "travel.payNow.SgPayment" });
  const { t: footer } = useTranslation("pages", { keyPrefix: "travel.payNow.sgFooter" });
  useEffect(() => {
    windowScroll();
  });

  return (
    <div className="flex flex-col min-h-screen gap-0">
      <RenewalHeader sgThankYou={true} />
      <div className="mb-8 flex-grow">
        <ThankYouMessage t={t} additionalcontent={true} applyTitleStyle={true} />
        <div className="container-flow mt-4">{t("success.paragraph1")}</div>
      </div>
      <Footer footer={footer} />
    </div>
  );
};

export default RenewalSuccess;
